import { createContext, useContext, ReactNode } from 'react';

interface LayoutContextValue {
  hasLayout: boolean;
}

const LayoutContext = createContext<LayoutContextValue>({ hasLayout: false });

export const useLayoutPresence = () => {
  return useContext(LayoutContext);
};

interface LayoutProviderProps {
  children: ReactNode;
}

export const LayoutProvider = ({ children }: LayoutProviderProps) => {
  return (
    <LayoutContext.Provider value={{ hasLayout: true }}>
      {children}
    </LayoutContext.Provider>
  );
};

export default LayoutContext;
